import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import BugManagement from '../components/BugManagement.vue'
import AuthManagement from '../components/AuthManagement.vue'
import UserLoginInfo from '../components/UserLoginInfo.vue'
import Login from '../components/Login.vue'
import HomePage from '../components/HomePage.vue'
import Welcome from '../components/Welcome.vue'
import RegisterPage from '../components/RegisterPage.vue'
import Features from '../components/Features.vue'
import PricingPage from '../components/PricingPage.vue'
import InterestedUsersManagement from '../components/InterestedUsersManagement.vue'
import authApi from '../js/connect.js'
import { syncThemeForRoute } from '../js/adminTheme'
import {
  clearLoginState,
  getAccessToken,
  getRefreshToken,
  isLoggedIn,
  isTokenValid,
  setAccessToken,
} from '../js/auth'

const routes = [
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/login', name: 'Login', component: Login },
  { path: '/features', name: 'Features', component: Features },
  { path: '/register', name: 'Register', component: RegisterPage },
  { path: '/dashboard', name: 'Dashboard', component: DashboardView, children: [
    { path: '/welcome', name: 'Welcome', component: Welcome },
    { path: '/auth-management', name: 'AuthManagement', component: AuthManagement },
    { path: '/bug-management', name: 'BugManagement', component: BugManagement },
    { path: '/user-login-info', name: 'UserLoginInfo', component: UserLoginInfo },
    { path: '/interested-users', name: 'InterestedUsersManagement', component: InterestedUsersManagement }
  ] },
  { path: '/pricing', name: 'Pricing', component: PricingPage },
];

const publicPaths = ['/', '/login', '/register', '/features', '/pricing']

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (publicPaths.includes(to.path)) {
    next();
    return;
  }

  if (!isLoggedIn()) {
    clearLoginState();
    next('/login');
    return;
  }

  const accessToken = getAccessToken();
  if (isTokenValid(accessToken)) {
    next();
    return;
  }

  const refreshToken = getRefreshToken();
  if (refreshToken) {
    try {
      const response = await authApi.refreshToken(refreshToken);
      setAccessToken(response.data.access_token);
      next();
      return;
    } catch (error) {
      console.error('Token刷新失败:', error);
      clearLoginState();
      next('/login');
      return;
    }
  }

  clearLoginState();
  next('/login');
});

router.afterEach((to) => {
  syncThemeForRoute(to.path);
});

export default router
